import { computed, unref } from 'vue'
import { useDisplay } from 'vuetify'

export function useMobileSearch2() {
    const display = useDisplay();

    return computed(() => {
      return unref(display.width) < 437
    });
}